namespace GeniuzPOS.Inventory {
    export interface IcStockCountCodeData extends Serenity.ListRequest {
        Header?: IcStockCountCodeRow;
        Details?: IcStockCountTranRow[];
        SysDocNo?: string;
        Para?: Administration.CsParaRow;
        URLpic?: string;
        BizName?: string;
        BizAddressLine1?: string;
        BizAddressLine2?: string;
        BizAddressLine3?: string;
        TaxId?: string;
    }
}
